import React from "react";
import {
  Timer,
  Sunrise,
  Clock,
  Calendar,
  CalendarClock,
  FileDigit,
  Thermometer,
  FileType2,
  ToggleLeft,
  Smartphone,
  Sparkles,
  HousePlug,
  BatteryMedium,
  Lightbulb,
  Fan,
  Blinds,
  Speaker,
  CirclePlay,
  SmartphoneNfc,
  AlignHorizontalJustifyCenter,
  Palette,
  CirclePower,
  SquareSquare,
  SquareStack,
  MessageCircleWarning,
  MessageCircle,
  MapPin,
  MessageSquareReply,
  Bell,
  PhoneCall,
  Volume2,
  CalendarDays,
  Hourglass,
  Sun,
  Cloudy,
  SquareArrowUp,
  CircleArrowUp,
  CircleFadingArrowUp,
} from "lucide-react";
import {
  HowToRegOutlined,
  DirectionsRunOutlined,
  Opacity,
  BroadcastOnHome,
  Nfc,
  DoDisturbOnOutlined,
  FlashlightOnOutlined,
} from "@mui/icons-material";

export const getTagIcon = (tag, size = 18) => {
  const iconProps = {
    size: size,
    style: {
      verticalAlign: "middle",
    },
  };

  const mProps = {
    sx: {
      fontSize: size,
      verticalAlign: "middle",
      display: "inline-flex",
      alignItems: "center",
    },
  };

  switch (tag) {
    case "Duration":
      return <Timer {...iconProps} />;
    case "SpecialTime":
    case "Time":
    case "TimeGeneral":
      return <Clock {...iconProps} />;
    case "Date":
    case "DateGeneral":
    case "SpecialDate":
    case "RelativeDate":
      return <Calendar {...iconProps} />;
    case "Timestamp":
      return <CalendarClock {...iconProps} />;
    case "Number":
      return <FileDigit {...iconProps} />;
    case "Temperature":
    case "TemperatureDiff":
      return <Thermometer {...iconProps} />;
    case "String":
      return <FileType2 {...iconProps} />;
    case "Bool":
      return <ToggleLeft {...iconProps} />;

    case "time":
      return <Clock {...iconProps} />;

    case "automation":
      return <Sparkles {...iconProps} />;
    case "device":
      return <HousePlug {...iconProps} />;

    case "widget":
    case "dataWidget":
      return <CircleArrowUp {...iconProps} />;
    case "buttonWidget":
      return <SquareArrowUp {...iconProps} />;
    case "circadianWidget":
      return <CircleFadingArrowUp {...iconProps} />;

    case "battery":
      return <BatteryMedium {...iconProps} />;

    case "light":
    case "brightness":
      return <Lightbulb {...iconProps} />;

    case "fan":
      return <Fan {...iconProps} />;
    case "window":
      return <Blinds {...iconProps} />;
    case "speaker":
      return <Speaker {...iconProps} />;
    case "media":
      return <CirclePlay {...iconProps} />;
    case "motionSensor":
    case "presenceSensor":
    case "lightSensor":
      return <SmartphoneNfc {...iconProps} />;
    case "contactSensor":
    case "contactState":
      return <AlignHorizontalJustifyCenter {...iconProps} />;
    case "temperatureSensor":
    case "temperature":
      return <Thermometer {...iconProps} />;
    case "humiditySensor":
    case "humidityState":
      return <Opacity {...mProps} />;
    case "colorRGB":
    case "colorTemperature":
      return <Palette {...iconProps} />;
    case "on/off":
      return <CirclePower {...iconProps} />;
    case "pressButton":
      return <SquareSquare {...iconProps} />;
    case "pressType":
      return <SquareStack {...iconProps} />;
    case "presenceState":
      return <HowToRegOutlined {...mProps} />;
    case "motionState":
      return <DirectionsRunOutlined {...mProps} />;
    case "broadcast":
      return <BroadcastOnHome {...mProps} />;

    case "quickWord":
      return <MessageCircleWarning {...iconProps} />;
    case "chat":
      return <MessageCircle {...iconProps} />;

    case "location":
      return <MapPin {...iconProps} />;
    case "sunMoon":
      return <Sunrise {...iconProps} />;

    case "notification":
      return <Bell {...iconProps} />;
    case "dialog":
      return <MessageSquareReply {...iconProps} />;
    case "ringer":
      return <PhoneCall {...iconProps} />;
    case "volume":
      return <Volume2 {...iconProps} />;
    case "schedule":
      return <CalendarDays {...iconProps} />;
    case "wait":
      return <Hourglass {...iconProps} />;
    case "illuminance":
      return <Sun {...iconProps} />;

    case "weather":
      return <Cloudy {...iconProps} />;

    // phone
    case "phone":
      return <Smartphone {...iconProps} />;
    case "phoneRinger":
      return <PhoneCall {...iconProps} />;
    case "phoneVolume":
      return <Volume2 {...iconProps} />;
    case "nfc":
      return <Nfc {...mProps} />;
    case "phoneDoNotDisturb":
      return <DoDisturbOnOutlined {...mProps} />;
    case "phoneFlashlight":
      return <FlashlightOnOutlined {...mProps} />;

    default:
      if (tag) console.log(tag);
      return null;
  }
};
